import React from 'react';
import { LaunchProvider } from './auth/LaunchProvider';
import GameApp from './game/GameApp';
import './App.css';

/**
 * App — top-level component.
 * Wraps everything in LaunchProvider which handles DraftKings
 * Casino API game launch (extracting URL params + InitSession).
 */
function App() {
  return (
    <LaunchProvider>
      <GameApp />
    </LaunchProvider>
  );
}

export default App;
